module.exports = __webpack_public_path__ + "antwebbuilding_new800x220.gif?d6b6bc27df1cb91f47f4d2a612b0da02";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/antwebbuilding_new800x220.gif
// module id = 90
// module chunks = 0